// Generated by ts-to-zod
import { z } from 'zod';
import { schemaSectionSchema } from '../../../schemas/models/schemaSection.schema';

export const suggestComputedFieldPayloadSchema = z.object({
  fieldSchemaId: z.string(),
  hint: z.string(),
  schemaContent: z.array(schemaSectionSchema),
  iterative: z.boolean().optional(),
  queryIndex: z.number().optional().nullable(),
});

export const suggestComputedFieldResultSchema = z.object({
  matching: z.object({
    configuration: z.record(z.unknown()),
  }),
});

export const suggestComputedFieldResponseSchema = z.object({
  results: z.array(suggestComputedFieldResultSchema),
});
